// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Form from 'church-theme-library/components/Form/Form'
import Image from 'church-theme-library/components/Image/Image'
import IconPhone from 'components/svg/phone-alt.svg'
import IconLocation from 'components/svg/map-marker-alt.svg'

class Contact extends React.Component {
	constructor() {
		super()

		this.state = {
			values: {}
		}
	}

	handleChange = ( id, value ) => {
		this.setState( {
			[ id ]: value
		} )
	}

	render() {
		const { translate, contentId, sectionId, data, locationAddress, phone } = this.props
		const { values } = this.state

		const imageData = data.image || {
			url: '',
			alt: '',
			aspect_ratio: '',
			focal_point: '',
			copy_space: '',
			width: '',
			height: '',
			thumb: '',
			srcset: '',
			type: ''
		}
		const formData = data.form || {
			id: ''
		}

		return (
			<div className="section-contact">
				<div className="-inner">
					<div className="-text">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="title"
							content={ data.title }
						/>

						<Editable
							element="p"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="content"
							content={ data.content }
						/>

						{ phone &&
							<div className="-info-item">
								<IconPhone />

								<p><a href={ `tel:${phone}` }>{ phone }</a></p>
							</div>
						}

						{ locationAddress &&
							<div className="-info-item">
								<IconLocation />

								<p><a href={ `https://www.google.com/maps/dir/Current+Location/${siteData.location_url_part}` } target="_blank" rel="noopener">{ locationAddress }</a></p>
							</div>
						}
					</div>

					<div className="-form">
						<div className="-form-form">
							{ ! formData.id &&
								<div className="editor-form-placeholder"></div>
							}

							<Editable
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="form"
								formId={ formData.id }
							>
								<Form
									data={ data.form }
									values={ values }
									handleChange={ this.handleChange }
								/>
							</Editable>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state ) => {
	return {
		locationAddress: state.site.locationAddress,
		phone: state.site.phone
	}
}

export default localize(
	connect( mapStateToProps )( Contact )
)
